<div class="overflow-auto">
  <ng-content></ng-content>
  <div #bottom class="height-2px"></div>
</div>
